<template>
    <div class=".container-fluid full-height">
        <NavBar></NavBar>


        <div class="row mt-5">
            <div class="col-12 ml-2 mr-2">

                <div class="KSpinner" v-if="isLoading">                    
                    <div class="spinner-border text-info"></div>
                    <h2 class="LoadingText">Loading....</h2>
                </div>
                
                    <div class=".continer" v-else>
                        <div class="iHScrollable">     

                            <v-data-table :headers="_headers" :items="data" class="elevation-1" :search="search">

                            <template v-slot:top>
                                <v-toolbar flat >
                                    <v-col cols="3"></v-col>
                                    <v-col cols="6" class="d-flex justify-space-around"> <v-toolbar-title class="iscreentitle">{{ getTitile }}</v-toolbar-title>  </v-col>
                                    <v-col cols="3"></v-col>                                    
                                </v-toolbar>
                                <v-text-field v-model="search" label="Search" class="mx-4"></v-text-field>
                            </template>

                            <template v-slot:item.actions="{ item }">
                                <button  class="btn btn-info m-0 mr-1 p-0 pl-1 pr-1" type="button" @click="viewItem(item.id)" data-toggle="tooltip" data-placement="top" title="View Seafarer"><font-awesome-icon icon="eye" size="sm"/></button>
                                <button  class="btn btn-info m-0 mr-1 p-0 pl-1 pr-1" type="button" @click="editItem(item.id)" data-toggle="tooltip" data-placement="top" title="Edit Seafarer" v-if="isUserLoggedIn && isUserAdminOrOperator"><font-awesome-icon icon="edit" size="sm"/></button>
                                <button  class="btn btn-info m-0 mr-1 p-0 pl-1 pr-1" type="button" @click="deleteItem(item.id)" data-toggle="tooltip" data-placement="top" title="Delete Seafarer" v-if="isUserLoggedIn && isUserAdmin"><font-awesome-icon icon="trash" size="sm"/></button>
                                <button  class="btn btn-info m-0 mr-1 p-0 pl-1 pr-1" type="button" @click="generateCV(item.id)" data-toggle="tooltip" data-placement="top" title="Generate Full CV" v-if="isUserLoggedIn && isUserAdminOrOperator"><font-awesome-icon icon="file-pdf" size="sm"/></button>
                                <button  class="btn btn-info m-0 mr-1 p-0 pl-1 pr-1" type="button" @click="generateCV2(item.id)" data-toggle="tooltip" data-placement="top" title="Generate CV" v-if="isUserLoggedIn && isUserAdminOrOperator"><font-awesome-icon icon="file" size="sm"/></button>
                            </template>
                            <template v-slot:item.createdAt="{ item }">
                               {{ formatDateTime(item.createdAt) }}
                            </template>
                            <template v-slot:item.modifiedAt="{ item }">
                               {{ formatDateTime(item.modifiedAt) }}
                            </template>
                            <template v-slot:item.client="{ item }">
                               {{ getClientName(item.client) }}
                            </template>

                            </v-data-table>
                            
                        </div>
                    </div>

                    <v-snackbar v-model="showSnackbar" >
                        {{ snackBarText }}
                        <template v-slot:action="{ attrs }"> <v-btn :color="snackbarColor" text v-bind="attrs" @click="showSnackbar = false">Close</v-btn></template>
                    </v-snackbar>

            </div>
        
        </div>    
        <Footer class="footerStickedToBottom" ></Footer>        

    </div>    
</template>

<script>

import NavBar  from '@/components/NavBar';
import Footer from '@/components/Footer';
import {DB} from '../firebase/db';
import Utils from '../utils/util';

export default {   
    name: 'SeafarerList',  
    data() {
        return {
            dialog:false,
            data:[],
            rankMap: null,

            currentPage: 1,
            perPage: 30,        
            
            isInitiating:false,
            isLoading:false,
            showSnackbar:false,
            snackBarText:'',
            snackbarColor:'green',
            
            propTitle:'',
            search:'',
        }
    },
    components: {          
        NavBar,         
        Footer,        
    },
    props:{
        propData:null,
    },
    created() {
        this.initRankMapForSorting();
        if(this.$route.params == undefined || this.$route.params.propData == undefined){
            this.fetchAll();
        }else{
            this.data = this.$route.params.propData;
            this.propTitle = this.$route.params.propTitle;
        }
        
    },
    methods: {  
        initRankMapForSorting(){
            this.rankMap = new Map();
            this.rankMap.set('MST', 1);
            this.rankMap.set('C/ENG', 2);
            this.rankMap.set('C/OFF', 3);
            this.rankMap.set('2/ENG', 4);
            this.rankMap.set('2/OFF', 5);
            this.rankMap.set('3/ENG', 6);
            this.rankMap.set('3/OFF', 7);
            this.rankMap.set('4/ENG', 8);
            this.rankMap.set('J/OFF', 9);
            this.rankMap.set('J/ENG', 10);
            this.rankMap.set('D/CDT', 11);
            this.rankMap.set('E/CDT', 12);  
            this.rankMap.set('ETR', 13);
            this.rankMap.set('ETO', 14);
            this.rankMap.set('P/MAN', 15);
            this.rankMap.set('FTR', 16);
            this.rankMap.set('BOSUN', 17);
            this.rankMap.set('BSN', 18);
            this.rankMap.set('AB', 19);
            this.rankMap.set('OS', 20);
            this.rankMap.set('MTM', 21);            
            this.rankMap.set('WPR', 22);            
            this.rankMap.set('C/COOK', 23);
            this.rankMap.set('COOK', 24);
            this.rankMap.set('MSM', 25);             
            this.rankMap.set('OLR', 26);
        },
        async fetchAll(){

            this.isLoading = true;
            const _this = this;
            this.data = [];

            DB.collection("seafarers").
                orderBy("modifiedAt", "desc").
                get()
                .then((querySnapshot) => {
                    querySnapshot.forEach((doc) => { 
                        _this.data.push(doc.data());
                    });
                    _this.data.sort((a,b) => {
                        if(this.rankMap.has(a.rankAppliedFor) && this.rankMap.has(b.rankAppliedFor)){
                            if(this.rankMap.get(a.rankAppliedFor) < this.rankMap.get(b.rankAppliedFor)) return -1;
                            else if(this.rankMap.get(a.rankAppliedFor) > this.rankMap.get(b.rankAppliedFor)) return 1;
                            else return a.surname < b.surname ? -1 : a.surname > b.surname ? 1 : 0;
                        }else if(this.rankMap.has(a.rankAppliedFor) && this.rankMap.has(b.rankAppliedFor) == false){
                            return -1;
                        }else if(this.rankMap.has(a.rankAppliedFor) == false && this.rankMap.has(b.rankAppliedFor) == true){
                            return 1;
                        }else{    
                            let comparisonStringA =  a.rankAppliedFor.toLowerCase() + "_" + a.surname;                       
                            let comparisonStringB =  b.rankAppliedFor.toLowerCase() + "_" + b.surname;                       
                            return comparisonStringA < comparisonStringB? -1: comparisonStringA > comparisonStringB.toLowerCase() ? 1:0;
                        }
                    })
                    _this.isLoading = false;
                })
                .catch((error) => {
                    _this.showError("Failed to fetch records. Error: ", error)
                    _this.data = [];
                    _this.isLoading = false;
                });
        },
        viewItem(id){
            var route = '/view-seafarer?id=' + id  + '&mode=view'          
            this.$router.push(route);
        },
        editItem(id){
            var route = '/edit-seafarer?id=' + id  + '&mode=edit'          
            this.$router.push(route);
        },
        deleteItem(id){
            const _this = this;
            if(confirm('Do you really want to delete the record?')){
                DB.collection('seafarers').doc(id).delete().then(() => {
                    _this.showMsg("Seafarers Deleted successfully!");
                    _this.fetchAll();
                }).catch((error) => {
                    _this.showError("Failed to delete Seafarers. Error: ", error)
                });
            }
        },
        showError(err){
            this.snackBarText = err;
            this.snackbarColor = 'red';
            this.showSnackbar = true;
        },          
        showMsg(msg){
            this.snackBarText = msg;
            this.snackbarColor = 'green';
            this.showSnackbar = true;
        },
        generateCV(id){
            var route = '/cv1?id=' + id         
            this.$router.push(route);
        },
        generateCV2(id){
            var route = '/cv2?id=' + id         
            this.$router.push(route);
        },
        formatDateTime(input){
            return Utils.formatDateTime(input);
        },
    },
    computed: {        
        getTitile(){
            if(this.propTitle == '')
                return 'Seafarers'
            else    
                return this.propTitle;
        },
        isUserLoggedIn(){
            return this.$store.state.user? true:false;
        },
        isUserAdmin(){
            if(this.$store.state.user != undefined && this.$store.state.user != null){
                if(this.$store.state.user.role != undefined && this.$store.state.user.role == 'Admin'){
                    return true;
                }
            }
            return false;
        },
        isUserAdminOrOperator(){
            if(this.$store.state.user != undefined && this.$store.state.user != null){
                if(this.$store.state.user.role != undefined && (this.$store.state.user.role == 'Admin' || this.$store.state.user.role == 'Operator')){
                    return true;
                }
            }
            return false;
        },
         _headers(){
            let headers =  [
                { text: 'Actions', align: 'start', sortable: false, value: 'actions', show:true}, 
                { text: 'Current Rank', align: 'start', sortable: true, value: 'rankAppliedFor', show:true}, 
                { text: 'Surname', align: 'start', sortable: true, value: 'surname', show:true},  
                { text: 'Other Name', align: 'start', sortable: true, value: 'otherName', show:true}, 
                { text: 'DOB', align: 'start', sortable: true, value: 'dob', show:true},          
                { text: 'UNK ID', align: 'start', sortable: true, value: 'unkID', show:true},          
                { text: 'Company ID Type', align: 'start', sortable: true, value: 'idType', show:true},          
                { text: 'Company ID', align: 'start', sortable: true, value: 'companyID', show:true},         
                         
                { text: 'Created By', align: 'start', sortable: true, value: 'createdBy', show:this.isUserAdmin},          
                { text: 'Created At', align: 'start', sortable: true, value: 'createdAt', show:this.isUserAdmin},          
                { text: 'Modified By', align: 'start', sortable: true, value: 'modifiedBy', show:this.isUserAdmin},          
                { text: 'Modified At', align: 'start', sortable: true, value: 'modifiedAt', show:this.isUserAdmin},          
            ];

             return headers.filter(x => x.show)
        }
        
    }, 
    
}


</script>



<style lang="scss">

</style>
